export enum RoleType {
  ADMIN = "Admin",
  ENGINEER = "Engineer",
  USER = "User",
  /**
   * Voyage managers are responsible for the Product Quality functionality.
   * Also known as Product Quality Users in Azure AAD
   */
  VOYAGE_MANAGER = "VoyageManager",
}

interface RoleTypeMetadata {
  displayName: string;
}

/**
 * Metadata for each role type
 * Needed display name specifically for the roles dropdown: https://zenergy.atlassian.net/browse/SUP-1664 
 */
export const RoleDetails: Record<RoleType, RoleTypeMetadata> = {
  [RoleType.ADMIN]: {
    displayName: "Admin"
  },
  [RoleType.ENGINEER]: {
    displayName: "Engineer",
  },
  [RoleType.USER]: {
    displayName: "User"
  },
  [RoleType.VOYAGE_MANAGER]: {
    displayName: "Voyage Manager"
  },
};